// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-stream-view {
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-left: 70px;
  margin-left: -54px;
  background-color: var(--primary-color-light-500);
  border-radius: 4px;
  max-width: calc(100% + 54px);
  overflow-x: clip;
}
@media screen and (max-width: 767px) {
  .chat-stream-view {
    padding: 0 8px;
    margin-left: 0;
    max-width: 100%;
  }
}
.chat-stream-view table {
  max-width: 100%;
  width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
  overflow-wrap: break-word;
  border-collapse: collapse;
}
.chat-stream-view table th, .chat-stream-view table td {
  padding: 6px 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  vertical-align: top;
}
@media screen and (max-width: 768px) {
  .chat-stream-view table {
    font-size: 0.8rem;
  }
  .chat-stream-view table th, .chat-stream-view table td {
    padding: 3px 4px;
  }
}
@media screen and (max-width: 480px) {
  .chat-stream-view table {
    font-size: 0.7rem;
  }
  .chat-stream-view table th, .chat-stream-view table td {
    padding: 2px 3px;
  }
}
.chat-stream-view img {
  max-width: 100%;
  height: auto;
}

.chat-stream-view-item:first-child {
  margin-top: 50px;
}

.chat-message {
  margin-bottom: 12px;
}

.chat-message.user {
  align-self: flex-end;
  background-color: #dcf8c6;
}

.chat-message.bot {
  align-self: flex-start;
  background-color: var(--primary-color-light-500);
}

.image-fullscreen-modal {
  position: fixed;
  inset: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.image-fullscreen-modal__close {
  position: absolute;
  top: 20px;
  right: 20px;
  color: white;
  font-size: 32px;
  cursor: pointer;
  z-index: 100000;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}
.image-fullscreen-modal__close:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.image-fullscreen-modal__close i {
  font-size: 28px;
}
.image-fullscreen-modal__image {
  max-width: 95%;
  max-height: 95%;
  object-fit: contain;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ChatStreamView/ChatStreamView.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gDAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AACF;AACE;EAXF;IAeI,cAAA;IACA,cAAA;IACA,eAAA;EADF;AACF;AAIE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAFJ;AAII;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAFN;AAKI;EAhBF;IAiBI,iBAAA;EAFJ;EAII;IACE,gBAAA;EAFN;AACF;AAKI;EAxBF;IAyBI,iBAAA;EAFJ;EAII;IACE,gBAAA;EAFN;AACF;AAOE;EACE,eAAA;EACA,YAAA;AALJ;;AAUE;EACE,gBAAA;AAPJ;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,oBAAA;EACA,yBAAA;AARF;;AAWA;EACE,sBAAA;EACA,gDAAA;AARF;;AAWA;EACE,eAAA;EACA,QAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AARF;AAUE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AARJ;AAUI;EACE,oCAAA;AARN;AAWI;EACE,eAAA;AATN;AAaE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAXJ","sourcesContent":[".chat-stream-view {\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  padding-left: 70px;\n  margin-left: -54px;\n  background-color: var(--primary-color-light-500);\n  border-radius: 4px;\n  max-width: calc(100% + 54px);\n  overflow-x: clip;\n\n  @media screen and (max-width: 767px) {\n    // The left gutter is already reserved by the parent .research__form__history-container\n    // at this breakpoint, so stacking a second negative-margin offset here only shrinks the\n    // usable content width and clips response text on narrow screens.\n    padding: 0 8px;\n    margin-left: 0;\n    max-width: 100%;\n  }\n\n  // Ensure tables shrink with container\n  table {\n    max-width: 100%;\n    width: 100%;\n    table-layout: fixed; // Equal column widths\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    border-collapse: collapse;\n\n    th, td {\n      padding: 6px 8px;\n      word-wrap: break-word;\n      overflow-wrap: break-word;\n      text-overflow: ellipsis;\n      vertical-align: top;\n    }\n\n    @media screen and (max-width: 768px) {\n      font-size: 0.8rem;\n      \n      th, td {\n        padding: 3px 4px;\n      }\n    }\n\n    @media screen and (max-width: 480px) {\n      font-size: 0.7rem;\n      \n      th, td {\n        padding: 2px 3px;\n      }\n    }\n  }\n\n  // Ensure images are responsive\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.chat-stream-view-item {\n  &:first-child {\n    margin-top: 50px;\n  }\n}\n\n.chat-message {\n  margin-bottom: 12px;\n}\n\n.chat-message.user {\n  align-self: flex-end;\n  background-color: #dcf8c6;\n}\n\n.chat-message.bot {\n  align-self: flex-start;\n  background-color: var(--primary-color-light-500);\n}\n\n.image-fullscreen-modal {\n  position: fixed;\n  inset: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.95);\n  z-index: 99999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  &__close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    color: white;\n    font-size: 32px;\n    cursor: pointer;\n    z-index: 100000;\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.8);\n    }\n\n    i {\n      font-size: 28px;\n    }\n  }\n\n  &__image {\n    max-width: 95%;\n    max-height: 95%;\n    object-fit: contain;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
